"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Portal_1 = require("./Portal");
Object.defineProperty(exports, "Portal", { enumerable: true, get: function () { return Portal_1.Portal; } });
//# sourceMappingURL=index.js.map